import { useTranslate } from "@refinedev/core";
import { Form, Input, Typography, Space, Alert } from "antd";
import type { FormInstance } from "antd";
import { WarningOutlined } from "@ant-design/icons";

const { Text, Paragraph } = Typography;

const CONFIRMATION_KEYWORD = "DELETE";

export default function DeleteAccount({
  form,
  onChange,
}: Readonly<{
  form: FormInstance;
  onChange: (isValid: boolean) => void;
}>) {
  const t = useTranslate();

  const handleOnChange = async () => {
    try {
      await form.validateFields();
      onChange(true);
    } catch {
      onChange(false);
    }
  };

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Alert
        type="warning"
        showIcon
        icon={<WarningOutlined />}
        message={t("pages.user.delete.warningTitle")}
        description={
          <Space direction="vertical" size="small">
            <Paragraph style={{ margin: 0 }}>
              {t("pages.user.delete.warningDescription")}
            </Paragraph>
            <ul style={{ margin: "8px 0", paddingLeft: "20px" }}>
              <li>{t("pages.user.delete.warningItem1")}</li>
              <li>{t("pages.user.delete.warningItem2")}</li>
              <li>{t("pages.user.delete.warningItem3")}</li>
            </ul>
          </Space>
        }
      />

      <div>
        <Text strong>{t("pages.user.delete.confirmIdentity")}</Text>
        <Paragraph type="secondary" style={{ marginTop: "8px" }}>
          {t("pages.user.delete.typeDeleteToConfirm", {
            keyword: CONFIRMATION_KEYWORD,
          })}
        </Paragraph>
      </div>
      <Form form={form} onChange={handleOnChange} layout="vertical">
        <Form.Item
          name="confirmation"
          rules={[
            {
              required: true,
              message: t("pages.user.delete.deletePhraseRequired", {
                keyword: CONFIRMATION_KEYWORD,
              }),
            },
            {
              validator: (_, value: string) =>
                value === CONFIRMATION_KEYWORD
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error(
                        t("pages.user.delete.deletePhraseDoesNotMatch", {
                          keyword: CONFIRMATION_KEYWORD,
                        })
                      )
                    ),
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          <Input
            size="large"
            placeholder={t("pages.user.delete.enterDeletePhrase", {
              keyword: CONFIRMATION_KEYWORD,
            })}
            autoComplete="off"
          />
        </Form.Item>
      </Form>
    </Space>
  );
}
